<template lang="pug">
.integrations-table
  IntegrationsBlock(v-for="integration in integrations" :key="integration.IdentificationCode" :integration="integration" @edit="open(integration)")
  IntegrationsModal(v-if="showModal" :code="code" @close="close")
</template>

<script>
import IntegrationsBlock from '@/vue/settings/application/integrations/IntegrationsBlock.vue'
import IntegrationsModal from '@/vue/settings/application/integrations/IntegrationsModal.vue'

export default {
  components: { IntegrationsBlock, IntegrationsModal },
  props: {
    integrations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      code: '',
      showModal: false,
    }
  },
  mounted: function() {
    this.checkOpen()
  },
  methods: {
    checkOpen() {
      const code = this.$route.query.open
      if (code) {
        this.code = code
        this.showModal = true
      }
    },
    open(integration) {
      this.code = integration.IdentificationCode
      this.showModal = true
    },
    close() {
      this.code = ''
      this.showModal = false
    },
  },
}
</script>
